<template>
    <div class="content">
        <div class="content-select">
            <el-row :gutter="20">
                <el-col :span="8">
                    <div class="select-title">
                        <div class="title-img">
                            <img src="@/assets/appraisal/select-icon.png" alt="">
                        </div>
                        <div class="title-info">
                            <span>{{ $route.query.pageType==1?'案件调查详情':'案件认定详情' }}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="2" :offset="14">
                    <div class="select-serch">
                       <el-button icon="el-icon-arrow-left" type="primary" size="small" @click="handleBack">返回</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
<!--      风险提示-->
      <div class="risk-tip" v-if="$route.query.pageType==1 &&(step1info.unitBlack || step1info.woundedBlack)">
        <img src="@/assets/warning-tip.png">
        <div class="tip-content">
          <p>风险提示</p>
          <div v-if="step1info.woundedBlack">伤者{{step1info.woundedName ||'-'}}（身份证号{{step1info.woundedIdNumber ||'-'}}）已被标记为【黑名单】，请经办人重点关注证据链真实性。</div>
          <div v-if="step1info.unitBlack">用人单位{{step1info.unitName ||'-'}}（企业信用代码{{step1info.unitCreditCode ||'-'}}）已被标记为【黑名单】，请经办人重点关注证据链真实性。</div>
        </div>
      </div>
       <div v-if="visibleTabs.length && $route.query.pageType==1" class="content-tabs">
        <myTabs :tabs="visibleTabs"  v-model="activeTab" @change="handleChange" />
         <div class="status" v-if="step1info.caseStatus">
           <img v-if="step1info.caseStatus==2" src="@/assets/images/Investigation/closed.webp" alt="这个是已结案的状态"  style="width:78px; height: 36px;"/>
           <img v-else src="@/assets/images/Investigation/Investigation.webp" alt="这个是调查中的状态" />
         </div>
       </div>
       <div class="content-info">
            <basic v-if="activeTab === 1" @step2Status="handleStep2Status" @step1info="getStep1info"/>
            <Investig v-else-if="activeTab === 2" :step1info="step1info"/>
            <Supplem v-else-if="activeTab === 3" :step2Status="step2Status"/>
            <Transcript v-else-if="activeTab === 4" :step2Status="step2Status"/>
            <Document v-else-if="activeTab === 5" />
            <Witness v-else-if="activeTab === 6" :step1info="step1info"/>
       </div>
    </div>
</template>

<script>
import myTabs from '@/components/myTabs/index.vue'
import basic from '../components/basic/index.vue'
import Investig from '../components/Investig/index.vue'
import Supplem from '../components/supplem/index.vue'
import Transcript from '../components/transcript/index.vue'
import Document from '../components/document/index.vue'
import Witness from '../components/witness/index.vue'
export default {
	components: {
		myTabs,
		basic,
		Investig,
		Supplem,
		Transcript,
		Document,
		Witness
	},
	data() {
		return {
            /** 全部 tab 配置，type=1 时只取「基本信息」 */
            allTabs: [
                { name: '案件信息', id: 1 },
                { name: '调查信息', id: 2 },
                { name: '补材通知', id: 3 },
                { name: '案件笔录', id: 4 },
                { name: '文书管理', id: 5 },
                { name: '证人管理', id: 6 }
            ],
            activeTab: 1,
            /** 调查信息已保存的数据，在「调查信息」Tab 保存后同步，在「基本信息」中只读展示 */
            investigFormData: {},
          step2Status:null,
          step1info:{}
        }
	},
	computed: {
		/** 根据路由 query.type：type=1 只看详情只显示基本信息，否则显示全部 */
		visibleTabs() {
			const type = this.$route.query.type;
			if (type === '1') {
				return this.allTabs.filter(t => t.id === 1);
			}
			return this.allTabs;
		}
	},
	watch: {
		'$route.query.type'() {
			this.activeTab = 1;
		}
	},
	created() {
		this.activeTab = 1;
	},
	methods: {
        handleStep2Status(e){
          this.step2Status = e
        },
        getStep1info(e){
          this.step1info=e
        },
        handleChange(tab) {
            this.activeTab = tab.id
        },
        handleBack() {
            this.$router.go(-1)
        },
        onInvestigSaved(data) {
            this.investigFormData = data ? { ...data } : {}
        }
	}
}
</script>


<style lang="scss" scoped>
.content {
    width: 100%;
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;

    &-select{
        height: 50px;
        .select-title{
            height: 46px;
            background: url('~@/assets/appraisal/selectBg.png') no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            gap: 12px;
            padding-left: 16px;
            .title-img{
                width: 18px;
                height: 18px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .title-info{
                color: var(--vt-c-black-mute-soft);
                font-size: 16px;
                font-weight: 700;
            }
        }
        .select-serch{
            margin-top: 12px;
            display: flex;
            align-items: center;
            gap: 8px;
            .serch-hint{
                color: var(--vt-c-black-mute-soft);
                font-size: 14px;
                font-weight: 400;
            }
            .serch-info{
                height: 28px;
                display: flex;
                align-items: center;
                gap: 12px;
                .info-item{
                    width: 120px;
                    height: 28px;
                    text-align: center;
                    line-height: 28px;
                    background: var(--vt-c-blue-mute);
                    color: var(--vt-c-blue);
                    border-radius: 2px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    
                    &:hover {
                        opacity: 0.8;
                    }
                    
                    &.active {
                        background: var(--vt-c-blue);
                        color: var(--vt-c-white);
                    }
                    
                    &:active:not(.active) {
                        transform: scale(0.98);
                    }
                }
            }
        }
    }
    &-tabs{
        margin-top: 16px;
        width: 100%;
        height: 36px;
        padding: 0 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      .status{
        height: 32px;
        margin-right: -24px;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    &-info{
        width: 100%;
        flex: 1;
        padding: 24px;
        overflow-y: auto;
        box-sizing: border-box;
    }
}
.risk-tip{
  margin-top: 16px;
  min-height: 96px;
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  background:url("~@/assets/warning-tip-bg.png") no-repeat , linear-gradient(90deg, rgba(248, 121, 123, 0) 0%, rgba(248, 121, 123, 0.15) 23.18%, rgba(248, 121, 123, 0) 100%), rgba(255, 255, 255, 0.44);
  display: flex;
  background-size: cover;
  background-position: center;
  align-items: center;
  padding-left: 200px;
  position: relative;
  padding-top: 16px;
  padding-bottom: 16px;
padding-right: 24px;
  img{
    width: 64px;
    height: 64px;
    margin-right: 24px;
  }
  .status{
    position: absolute;
    right: 24px;
    top: 0px;
    height: 32px;
    margin-right: -24px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .tip-content{
    p{
      height: 22px;
      color: rgba(249, 69, 72, 1);
      font-family: "Alibaba PuHuiTi 3.0";
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
    }
    div{
      margin-top: 8px;
      color: rgba(37, 45, 74, 1);
      font-family: "Alibaba PuHuiTi 3.0";
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
    }
  }
}
</style>